var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCloseLinear = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37201 2.46967C3.66491 2.17678 4.13978 2.17678 4.43267 2.46967L8.90234 6.93934L13.372 2.46967C13.6649 2.17678 14.1398 2.17678 14.4327 2.46967C14.7256 2.76256 14.7256 3.23744 14.4327 3.53033L9.963 8L14.4327 12.4697C14.7256 12.7626 14.7256 13.2374 14.4327 13.5303C14.1398 13.8232 13.6649 13.8232 13.372 13.5303L8.90234 9.06066L4.43267 13.5303C4.13978 13.8232 3.66491 13.8232 3.37201 13.5303C3.07912 13.2374 3.07912 12.7626 3.37201 12.4697L7.84168 8L3.37201 3.53033C3.07912 3.23744 3.07912 2.76256 3.37201 2.46967Z",
    fill: "#94B8BF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloseLinear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_close_linear.71cffcef48bf199311e2ba8a0f4cfb15.svg";